import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import ButtonLink from '../../../components/link/link.component';
import { useAuth } from 'utils/contexts/auth-context';
import { useFlags } from 'launchdarkly-react-client-sdk';
import MainButton from 'shared/components/button/main-button.component';

const LoginSelectorForm: FC = () => {
  const { auth0Login } = useAuth();

  const { vrs_sign_in } = useFlags();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
      }}
    >
      <Typography sx={{ fontWeight: '700', fontSize: '18px' }}>
        Sign in with
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <Typography variant='subtitle2'>Your paid Sorenson account</Typography>
        <MainButton onClick={auth0Login}>Email</MainButton>
        <Typography variant='caption'>
          Use the email address associated with your enterprise VRI account.
        </Typography>
      </Box>
      {vrs_sign_in && (
        <>
          <Typography sx={{ fontWeight: 'bold', fontSize: '12px' }}>
            OR
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
            }}
          >
            <Typography variant='subtitle2'>
              Your Sorenson VRS account
            </Typography>
            <ButtonLink to='vrs' text='Sorenson phone number' />
            <Typography variant='caption'>
              Use a phone number you have for any of your videophone devices or
              apps.
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default LoginSelectorForm;
